import { Component, input, SimpleChanges } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { MarkdownService } from '../markdown.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-markdown',
  standalone: true,
  imports: [
    CommonModule

  ],
  template: `<div [innerHtml]="content"></div>`,
  styleUrl: './markdown.component.scss'
})
export class MarkdownComponent {
  markdown = input<string>('');
  content: SafeHtml = '';

  constructor(
    private markdownService: MarkdownService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['markdown'] && changes['markdown'].currentValue) {
      this.updateContent();
    }
  }

  private updateContent(): void {
    const rawContent = this.markdownService.convert(this.markdown());
    this.content = this.sanitizer.bypassSecurityTrustHtml(rawContent);
  }

}
